import { getPowerAssetsGroupColor } from "./getPowerAssetsGroupColor";
import { ReactComponent as InstalledIcon } from "../../../../assets/images/power-assets/installed.svg";
import { ReactComponent as PendingIcon } from "../../../../assets/images/power-assets/pending.svg";
import { ReactComponent as InProgressIcon } from "../../../../assets/images/power-assets/inprogress.svg";

function getPowerAssetsGroupIcon(recommendedPowerAssetsGroupStatus) {
  switch (recommendedPowerAssetsGroupStatus) {
    case "installed":
      return InstalledIcon;
    case "inprogress":
      return InProgressIcon;
    case "pending":
      return PendingIcon;
    default:
      return undefined;
  }
}

export function recommendedPowerAssetsDataNormalizer(recommendedPowerAssetsGroups) {
  return recommendedPowerAssetsGroups.map((recommendedPowerAssetsGroup, i) => {
    return {
      startDate: new Date(recommendedPowerAssetsGroup["start_date"]).getTime(),
      endDate: new Date(recommendedPowerAssetsGroup["end_date"]).getTime(),
      yoffset: recommendedPowerAssetsGroups.length * 40 - 30 * i,
      type: recommendedPowerAssetsGroup.type,
      count: recommendedPowerAssetsGroup.count,
      location: recommendedPowerAssetsGroup.location,
      color: getPowerAssetsGroupColor(recommendedPowerAssetsGroup.type),
      icon: getPowerAssetsGroupIcon(recommendedPowerAssetsGroup.status),
    };
  });
}
